import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {OrderItemReasonService} from 'app/blocks/service/api/order-item-reason.service';
import {Resource} from 'app/constants/resource';

import {ENTITIES_SETUP_BASE_URL} from 'app/app.constants';
import {OrderItemReason, IOrderItemReason} from 'app/blocks/model/order-item-reason.model';
import {EntityNavigator} from 'app/blocks/routing/navigator';
import {EntityUrlProvider} from 'app/blocks/routing/entity-url-provider';
import {AbstractEntityResource} from 'app/blocks/resource/abstract-entity-resource';

@Injectable({
    providedIn: 'root'
})
export class OrderItemReasonResource extends AbstractEntityResource<IOrderItemReason> {
    constructor(orderItemService: OrderItemReasonService, router: Router) {
        super(
            Resource.ORDER_ITEM_REASONS,
            orderItemService,
            new EntityNavigator(ENTITIES_SETUP_BASE_URL, Resource.ORDER_ITEM_REASONS, router),
            new EntityUrlProvider(ENTITIES_SETUP_BASE_URL, Resource.ORDER_ITEM_REASONS),
            (entity?) => new OrderItemReason(entity),
            (entity) => entity.code
        );
    }
}
